export const AVATAR_API = "https://ui-avatars.com/api";
export const API = "https://partes.teambike.com/api/api";
export const AUTH_TOKEN = "authToken";
export const BEARER = "Bearer";
